import React from "react";
import styles from "./index.module.scss";
import Game from "../pages/game";

function App() {
  return (
    <div className={styles.app}>
      <Game />
    </div>
  );
}

export default App;
